<template>
    <div
        class="content-media-header content-image-header banner-enabled"
        :class="`text-theme-${variant.textTheme ?? 'light'}`"
    >
        <!-- Background Image -->
        <v-img
            class="fill-width fill-height"
            :src="imageAttrs.sizesMap.large"
            :srcset="imageAttrs.srcset"
            sizes="100vw"
            :alt="alt ?? ''"
            cover
        ></v-img>

        <!-- Header Content -->
        <div class="slot-header max-container mx-auto px-4 px-md-6 pt-4">
            <slot />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useFullImage } from '~/composables';
    import type { BannerImageVariant, FullImageGeneratedSizes } from '~/types';

    const props = defineProps({
        variant: {
            type: Object as PropType<BannerImageVariant>,
            required: true
        },
        alt: {
            type: String as PropType<Nilish<string>>,
            default: null
        }
    });

    const { getImgAttrsFromFullImage } = useFullImage();

    // The variant's `url` is the FullImage dynamic URL, so the sized srcset
    // derives from it. The banner is full-bleed, hence `sizes="100vw"`.
    const imageAttrs = computed<FullImageGeneratedSizes>(() => getImgAttrsFromFullImage({
        uid: props.variant.uid,
        url: props.variant.url,
        alt: props.alt ?? '',
        showDropShadow: false,
        clippedEdges: []
    }));
</script>

<style lang="scss"></style>
